export default {
    ja_JP: 'ja_JP',
    en_US: 'en_US'
}